import { Trans } from 'react-i18next';
import { Alert, AlertIcon, AlertDescription } from '@chakra-ui/react';

export const Error = () => {
  return (
    <Alert status="error" mb={4}>
      <AlertIcon />
      <AlertDescription>
        <Trans>There was an error! Please try again.</Trans>
      </AlertDescription>
    </Alert>
  );
};
